import { useEffect } from 'react';
import steps from '../survey/steps';

export default function useOnboardingLoadTracker(): void {
  useEffect(() => {
    const onLoad = () => {
      setTimeout(() => {
        const { loadEventEnd, navigationStart } = performance.timing;
        const loadTime = (loadEventEnd - navigationStart) / 1000;

        if (loadEventEnd > 0 && loadTime > 0) {
          steps.analytics.send({
            event: {
              event: 'onboarding_loading',
              loading_time: loadTime,
            },
          });
        } else {
          console.warn('Метрика загрузки некорректна:', loadTime);
        }
      }, 0);
    };

    if (document.readyState === 'complete') {
      onLoad();
      return undefined;
    }
    window.addEventListener('load', onLoad);
    return () => window.removeEventListener('load', onLoad);
  }, []);
}
